var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elmUpload"},[_c('input',{ref:"myFile",attrs:{"type":"file","accept":_vm.accept,"disabled":_vm.disabled,"single":""},on:{"change":_vm.change}})])
}
var staticRenderFns = []

export { render, staticRenderFns }